import { type RootState } from '@/store';

export const isModalOpen = ({ modal: { isModalOpen } }: RootState) =>
  isModalOpen;

export const selectCurrentModal = (state: RootState) => {
  const { stack } = state.modal;
  return stack && stack.length > 0 ? stack[stack.length - 1] : null;
};
